import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useBreakpoints } from './useBreakpoints';
/**
 * Renders children if conditions are met
 */
export function MatchBreakpoint(props) {
    var _a = useBreakpoints(), currentBreakpoint = _a.currentBreakpoint, breakpoints = _a.breakpoints;
    if (props.is != null) {
        if (Array.isArray(props.is)) {
            if (props.is.indexOf(currentBreakpoint) < 0) {
                return _jsx(Fragment, {}, void 0);
            }
        }
        else {
            if (currentBreakpoint !== props.is) {
                return _jsx(Fragment, {}, void 0);
            }
        }
    }
    if (props.not != null) {
        if (Array.isArray(props.not)) {
            if (props.not.indexOf(currentBreakpoint) >= 0) {
                return _jsx(Fragment, {}, void 0);
            }
        }
        else {
            if (currentBreakpoint === props.not) {
                return _jsx(Fragment, {}, void 0);
            }
        }
    }
    if (props.min != null) {
        if (breakpoints[currentBreakpoint] < breakpoints[props.min]) {
            return _jsx(Fragment, {}, void 0);
        }
    }
    if (props.max != null) {
        if (breakpoints[currentBreakpoint] > breakpoints[props.max]) {
            return _jsx(Fragment, {}, void 0);
        }
    }
    return _jsx(Fragment, { children: props.children }, void 0);
}
//# sourceMappingURL=MatchBreakpoint.js.map